<template>
    <Drawer class-name="nav-drawer" v-model="isDrawer" placement="left">
        <p slot="header"><img src="static/nav-logo-blue.png" style="height: 20px;"/></p>
        <Menu accordion active-name="1">
            <MenuItem :name="drawerMenu.top.id" v-if="false" @click.native="onItem(drawerMenu.top)">{{ $common.config.lang === 'cn' ? drawerMenu.top.cnName : drawerMenu.top.enName }}</MenuItem>
            <Submenu :name="item.id" v-for="(item, index) in drawerMenu.center" :key="item.id">
                <template slot="title">{{ $common.config.lang === 'cn' ? item.cnName : item.enName }}</template>
                <MenuItem :name="child.id" v-for="(child, index) in item.children" :key="child.id" @click.native="onItem(child)">{{ child.name }}</MenuItem>
            </Submenu>
            <MenuItem :name="item.id" v-for="(item, index) in drawerMenu.bottom" :key="item.id" :to="item.path ? item.path : false" @click.native="onItem(item)">{{ $common.config.lang === 'cn' ? item.cnName : item.enName }}</MenuItem>
        </Menu>
        <a class="d-block" target="_blank" href="https://vt.anysonus.com:9999/login" v-if="false" style="padding: 14px 24px;">{{ $common.config.lang === 'cn' ? '控制面板' : 'Control' }}</a>
    </Drawer>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                isDrawer: false,
                drawerMenu: {
                    top: this.$common.config.navigation[0],
                    center: this.$common.config.navigation.slice(0, 2),
                    bottom: this.$common.config.navigation.slice(2, 5),
                },
            }
        },
        created() {
            console.log('this.drawerMenu---------->', this.drawerMenu);
        },
        mounted() {
            this.$bus.on('toggleSidebar', (data, object) => {
                if (data){
                    this.isDrawer = data;
                }
            });
        },
        methods: {
            onItem(data){
                console.log('this.onMenuItem---------->', data);
                if (data.path === '/product'){
                    this.$router.push({
                        path: data.path,
                        query: {
                            id: data.id
                        }
                    });
                    this.$bus.emit('loadProduct', true);
                } else if (data.path === '/solution'){
                    this.$router.push({
                        path: data.path,
                        query: {
                            id: data.id,
                            model: 'solution',
                        }
                    });
                    this.$bus.emit('loadSolution', true);
                } else {
                    this.$router.push({
                        path: data.path,
                    });
                }
                // if (data.id === '5'){
                //     window.open(data.path);
                // }
                this.isDrawer = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue